import React from 'react';
import isEmpty from 'lodash/isEmpty';
import EditableText from '../../editor/EditableText';

export const Method = (filter, row) => {
  const value = Array.isArray(row[filter.id])
    ? row[filter.id].length
    : row[filter.id];
  return (
    isEmpty(filter.value) ||
    (filter.value[0] <= value && value <= filter.value[1])
  );
};

export class Filter extends React.PureComponent {
  state = {
    value: ''
  };

  onChange = filter => {
    let range = filter.split('-', 2);

    if (range.length === 2) {
      if (range[0] === '') range[0] = '0';
      if (range[1] === '') range[1] = 'Infinity';
    } else {
      if (filter === '') range = [];
      else range = [filter, filter];
    }

    range = range.map(v => parseFloat(v, 10));
    this.setState({ value: filter }, () => this.props.onChange(range));
  };

  render() {
    return (
      <EditableText
        hideIcon={true}
        noLang={true}
        placeholder="0-1000"
        finishEdit={this.onChange}
      />
    );
  }
}
